import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
import occurrences from './occurrences'
/**
* @see \App\Http\Controllers\Teacher\ScheduleController::index
* @see app/Http/Controllers/Teacher/ScheduleController.php:30
* @route '/teacher/schedules'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/schedules',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::index
* @see app/Http/Controllers/Teacher/ScheduleController.php:30
* @route '/teacher/schedules'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::index
* @see app/Http/Controllers/Teacher/ScheduleController.php:30
* @route '/teacher/schedules'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::index
* @see app/Http/Controllers/Teacher/ScheduleController.php:30
* @route '/teacher/schedules'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::sessions
* @see app/Http/Controllers/Teacher/ScheduleController.php:70
* @route '/teacher/schedules/sessions'
*/
export const sessions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sessions.url(options),
    method: 'get',
})

sessions.definition = {
    methods: ["get","head"],
    url: '/teacher/schedules/sessions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::sessions
* @see app/Http/Controllers/Teacher/ScheduleController.php:70
* @route '/teacher/schedules/sessions'
*/
sessions.url = (options?: RouteQueryOptions) => {
    return sessions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::sessions
* @see app/Http/Controllers/Teacher/ScheduleController.php:70
* @route '/teacher/schedules/sessions'
*/
sessions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sessions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::sessions
* @see app/Http/Controllers/Teacher/ScheduleController.php:70
* @route '/teacher/schedules/sessions'
*/
sessions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sessions.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::generateLessonSpace
* @see app/Http/Controllers/Teacher/ScheduleController.php:190
* @route '/teacher/schedules/{schedule}/generate-lesson-space'
*/
export const generateLessonSpace = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generateLessonSpace.url(args, options),
    method: 'post',
})

generateLessonSpace.definition = {
    methods: ["post"],
    url: '/teacher/schedules/{schedule}/generate-lesson-space',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::generateLessonSpace
* @see app/Http/Controllers/Teacher/ScheduleController.php:190
* @route '/teacher/schedules/{schedule}/generate-lesson-space'
*/
generateLessonSpace.url = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { schedule: args }
    }

    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: args.schedule,
    }

    return generateLessonSpace.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::generateLessonSpace
* @see app/Http/Controllers/Teacher/ScheduleController.php:190
* @route '/teacher/schedules/{schedule}/generate-lesson-space'
*/
generateLessonSpace.post = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generateLessonSpace.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::updateNote
* @see app/Http/Controllers/Teacher/ScheduleController.php:160
* @route '/teacher/schedules/{schedule}/note'
*/
export const updateNote = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateNote.url(args, options),
    method: 'put',
})

updateNote.definition = {
    methods: ["put"],
    url: '/teacher/schedules/{schedule}/note',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::updateNote
* @see app/Http/Controllers/Teacher/ScheduleController.php:160
* @route '/teacher/schedules/{schedule}/note'
*/
updateNote.url = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { schedule: args }
    }

    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: args.schedule,
    }

    return updateNote.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::updateNote
* @see app/Http/Controllers/Teacher/ScheduleController.php:160
* @route '/teacher/schedules/{schedule}/note'
*/
updateNote.put = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateNote.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::enrolledStudents
* @see app/Http/Controllers/Teacher/ScheduleController.php:110
* @route '/teacher/schedules/{schedule}/enrolled-students'
*/
export const enrolledStudents = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enrolledStudents.url(args, options),
    method: 'get',
})

enrolledStudents.definition = {
    methods: ["get","head"],
    url: '/teacher/schedules/{schedule}/enrolled-students',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::enrolledStudents
* @see app/Http/Controllers/Teacher/ScheduleController.php:110
* @route '/teacher/schedules/{schedule}/enrolled-students'
*/
enrolledStudents.url = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { schedule: args }
    }

    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: args.schedule,
    }

    return enrolledStudents.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::enrolledStudents
* @see app/Http/Controllers/Teacher/ScheduleController.php:110
* @route '/teacher/schedules/{schedule}/enrolled-students'
*/
enrolledStudents.get = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enrolledStudents.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleController::enrolledStudents
* @see app/Http/Controllers/Teacher/ScheduleController.php:110
* @route '/teacher/schedules/{schedule}/enrolled-students'
*/
enrolledStudents.head = (args: { schedule: string | number } | [schedule: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: enrolledStudents.url(args, options),
    method: 'head',
})

const schedules = {
    index: Object.assign(index, index),
    sessions: Object.assign(sessions, sessions),
    generateLessonSpace: Object.assign(generateLessonSpace, generateLessonSpace),
    updateNote: Object.assign(updateNote, updateNote),
    enrolledStudents: Object.assign(enrolledStudents, enrolledStudents),
    occurrences: Object.assign(occurrences, occurrences),
}

export default schedules